<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-print"
          id="btn_print_drive_behavior"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ReportDriveBehavior />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ReportDriveBehavior from '@/components/reports/drivebehavior/DriveBehavior'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'ReportDriveBehaviorList',
  components: {
    PageTitle,
    PageRowWrapper,
    ReportDriveBehavior,
    ActionButton
  }
}
</script>
